<template>
  <div>
    <div class='jumbotron-background'>
      <div class='container'>
        <h1>{{ $t('jumbotron.heading') }}</h1>
        <p>{{ $t('jumbotron.heading2') }}</p>
        <br>
        <p>{{ $t('jumbotron.slogan') }}</p>
      </div>
    </div>

    <div class='container'>
      <div class='content-module-wrapper' style='border-top-color: transparent'>
        <div class='content-module'>
          <div class='row'>
            <div class='col-lg-6'>
              <h3>{{ $t('enter_barcode') }}</h3>
              <search-form v-model='search' @error='setError' @submit='submit' example='4000001000005' />
            </div>
            <div class='col-lg-6 bullets'>
              <p>
                <span class='fa fa-check-circle color-grass'></span> {{ $t('bullets.1') }}
              </p>
              <p>
                <span class='fa fa-check-circle color-grass'></span> {{ $t('bullets.2') }}
              </p>
              <p>
                <span class='fa fa-check-circle color-grass'></span> {{ $t('bullets.3') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <search-form-alerts v-if='error' :error='error' @suggest='applySuggestion'></search-form-alerts>
      <!-- spacer in case no errors -->
      <div v-else style='height: 142px' />
    </div>

    <div class='container' style='margin-top: 15px; margin-bottom: 50px'>
      <div class='content-module-wrapper' style='border-top-color: transparent'>
        <div class='content-module'>
          <div class='row'>
            <div class='col'>
              <h3>{{ $t('enter_company') }}</h3>
              <company-search-form @submit='companySubmit' />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchForm from '@/components/SearchForm'
import SearchFormAlerts from '@/components/SearchFormAlerts'
import CompanySearchForm from '../../components/CompanySearchForm.vue'

export default {
  name: 'Start',
  components: {
    CompanySearchForm,
    SearchForm,
    SearchFormAlerts
  },
  data() {
    return {
      error: null,
      search: ''
    }
  },
  methods: {
    applySuggestion(suggestion) {
      this.search = suggestion
      this.submit(suggestion)
    },
    setError(error) {
      this.error = error
    },
    submit(search) {
      this.$router.push({ name: 'Result', params: { search } })
    },
    companySubmit(companySearch) {
      this.$router.push({
        name: 'Companies',
        query: {
          q: encodeURI(JSON.stringify(companySearch))
        }
      })
    }
  },
  i18n: {
    messages: {
      de: {
        jumbotron: {
          heading: 'Verified by GS1',
          heading2: 'Vertrauen und Effizienz beginnen bei verlässlichen Informationen',
          slogan: 'Verified by GS1 bietet verlässliche Produkt-, Unternehmens- und Standortinformationen für Geschäftspartner und Regierungsstellen'
        },
        enter_barcode: 'Geben Sie eine GTIN/EAN oder GLN ein',
        enter_company: 'Suchen Sie nach einer Firma',
        bullets: {
          1: 'Produkte und Standorte einfach identifizieren',
          2: 'Unternehmensinformationen prüfen',
          3: 'Datenbereitstellung durch Markeninhaber'
        }
      },
      en: {
        jumbotron: {
          heading: 'Verified by GS1',
          heading2: 'Trust and efficiency start with a valid ID',
          slogan: 'Verified by GS1 provides unique, trusted and verifiable product, company and location information for business partners and government entities'
        },
        enter_barcode: 'Enter a GTIN/EAN or GLN',
        enter_company: 'Search for a company',
        bullets: {
          1: 'Easily identify products and locations',
          2: 'Verify company information',
          3: 'Data provision by brand owners'
        }
      }
    }
  }
}
</script>

<style scoped>
.toolkit .content-module-wrapper {
  margin-top: -40px;
}

.toolkit .content-module {
  padding: 40px;
}

.toolkit .content-module h3 {
  border: none;
  color: var(--gs1-dark-gray);
  font-size: 24px;
  font-weight: 500;
}

.toolkit .content-module .bullets {
  padding-top: 22px;
  font-weight: normal;
}

.toolkit .content-module .bullets .fa {
  font-size: 24px;
}

.toolkit .content-module .bullets p {
  color: var(--gs1-dark-gray);
  font-size: 20px;
  line-height: 2.25;
}
</style>



// WEBPACK FOOTER //
// src/router/views/Start.vue